import { RouteGroup } from '@Constants/routes';
import InstructorCodes from '../InstructorCodes';

/**
 * The unlock-center-classroom codes (`instructor_codes` table) — NOT the
 * instructor-targeted scratchcards, which live in the Scratch Cards tab.
 */
export const InstructorCodesRoute: RouteGroup = {
	isRouted: true,
	title: 'Unlock Center Codes',
	route: 'instructor-codes',
	icon: 'badge',
	code: 'v-instc',
	// A used code's whole purpose is keeping a student's CENTER CLASSROOMS
	// visible, and Analytics' UsageTab already treats unlock codes as
	// classroom-mode-only — the nav entry should agree with it.
	requiresClassrooms: true,
	routes: [],
	component: <InstructorCodes />,
};
